import { render, staticRenderFns } from "./PrkTable.vue?vue&type=template&id=fe6256e6&scoped=true&"
import script from "./PrkTable.vue?vue&type=script&lang=js&"
export * from "./PrkTable.vue?vue&type=script&lang=js&"
import style0 from "./PrkTable.vue?vue&type=style&index=0&id=fe6256e6&scoped=true&lang=scss&"
import style1 from "./PrkTable.vue?vue&type=style&index=1&id=fe6256e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6256e6",
  null
  
)

export default component.exports